import Alpine from 'alpinejs';
import axios from 'axios';
import { Loader } from '@googlemaps/js-api-loader';
import { screens } from '../../../../config/breakpoints';
import { getCookie, setCookie } from '../../../assets/scripts/utils/cookies';

const desktop = screens.desktop.replace(/[^\d.-]/g, '');
const mql = window.matchMedia(`(max-width: ${desktop}px)`);

Alpine.data('branches', () => ({
  locations: [],
  searchZip: '',
  isOpen: '',
  wasMapsCookieAccepted: false,
  invalidZip: false,

  init() {
    this.getLocations();
    
  },

  getLocations() {
    let acceptedCookies = getCookie('cookiebanner.services.accepted');
    if (acceptedCookies) {
      acceptedCookies = acceptedCookies.split(',');
      if (acceptedCookies.includes('googleMaps')) {
          this.wasMapsCookieAccepted = true;
      }
    } 
    const branches = this.$refs.branches;
    const { url } = branches.dataset;
    axios
      .get(url)
      .then(response => {
        const { locations } = response.data;
        if (locations.length > 0) {
          this.locations = locations;
          if(this.wasMapsCookieAccepted) {
            this.initMaps();
          }
        }
      })
  },

  setMapsCookie() {
    let acceptedCookies = getCookie('cookiebanner.services.accepted');
    acceptedCookies = acceptedCookies.length > 0 ? acceptedCookies.split(',') : [];
    if (acceptedCookies.includes('googleMaps')) {
      this.wasMapsCookieAccepted = true;
      this.initMaps();
    } else {
      acceptedCookies.push('googleMaps');
      setCookie('cookiebanner.services.accepted', acceptedCookies.join(','), 365);
      this.wasMapsCookieAccepted = true;
      this.initMaps();
    }
  },

  findLocation() {
    const branches = this.$refs.branches;
    const { searchUrl } = branches.dataset;
    if (this.searchZip) {
      if(!new RegExp('^[0-9]*$').test(this.searchZip)) {
        this.invalidZip = true;
      } else {
        this.invalidZip = false;
      }
    } else {
      this.invalidZip = true;
    }
    if(!this.invalidZip) {
      axios
        .get(searchUrl, {
          params: { searchZip: this.searchZip },
        })
        .then(response => {
          if(response.data.branchId) {
            this.invalidZip = false;
            let branchCityId;
            this.locations.forEach((countryLocations) => {
              countryLocations.cities.forEach((location) => {
                location.branches.find((branch) => {
                  if (branch.branchId === response.data.branchId) {
                    branchCityId = location.cityId;
                  }
                })
              })
            })
            this.isOpen = branchCityId;
            document.getElementById(branchCityId).scrollIntoView({ behavior: "smooth" });
            const closestBranch = document.querySelector(`[data-branch-id='${response.data.branchId}']`)
            if(closestBranch) {
              const currentlySelected = document.querySelector('.marker-selected-icon');
              if (currentlySelected) {
                currentlySelected.className = 'marker-icon';
              }
              closestBranch.className = 'marker-selected-icon';
            }
          } else {
            this.invalidZip = true;
          }
        })
    }
  },

  focusMarker(cityId) {
    this.locations.forEach((countryLocations) => {
      const selectedLocation = countryLocations.cities.find((location) => location.cityId === cityId)
      if(selectedLocation) {
        // mark selected accordeon element on map
        // when more than one branch per location mark the last one to make it visible as the markers are layered on top of another 
        const firstBranchId = selectedLocation.branches[selectedLocation.branches.length - 1].branchId
        const firstBranchElement = document.querySelector(`[data-branch-id="${firstBranchId}"]`);
        const currentlySelected = document.querySelector('.marker-selected-icon');
        if (currentlySelected) {
          currentlySelected.className = 'marker-icon';
        }
        firstBranchElement.className = 'marker-selected-icon';
        this.isOpen = cityId;
      }
    })
  },

  initMaps() {
    const loader = new Loader({
      apiKey: "AIzaSyC2vMdxTkEKRX6dFKqIpBgv_B5NcgIWDc8",
      version: "weekly",
      libraries: []
    });
    
    const mapOptions = {
      center: { lat: 51.1657, lng: 10.4515 },
      zoom: mql.matches ? 6.0 : 6.6,
      mapId: '6f24b3b82a52c99c'
    };
    
    loader
      .importLibrary('maps')
      .then(async ({ Map }) => {
        const map = new Map(document.getElementById("map"), mapOptions);
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        this.locations.forEach((countryLocations) => {
          countryLocations.cities.forEach((location) => {
            location.branches.forEach((branch) => {
              const icon = document.createElement("div");
              icon.className = 'marker-icon';
              // set branch id as attribute to be able to find marker in zip search
              icon.setAttribute('data-branch-id', branch.branchId)
              window['branch' + branch.branchId] = new AdvancedMarkerElement({
                map,
                position: { lat: parseFloat(branch.lat), lng: parseFloat(branch.long) },
                content: icon,
                id: branch.branchId,
                title: branch.name
              });

              window['branch' + branch.branchId].addListener('click', () => {
                const currentlySelected = document.querySelector('.marker-selected-icon');
                if (currentlySelected) {
                  currentlySelected.className = 'marker-icon';
                }
                const selectedIcon = document.createElement("div");
                selectedIcon.className = 'marker-selected-icon';
                window['branch' + branch.branchId].content = selectedIcon;
                this.isOpen = location.cityId;
                document.getElementById(location.cityId).scrollIntoView({ behavior: "smooth" });
              });
            })
          })
        })
      })
        
      .catch(() => {
      });
  }
}));
